module.exports = __webpack_public_path__ + "DINNextLTPro-Black.eot?c71d1ebc96739d6dd95bd93807b7fb8a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Black.eot
// module id = 323
// module chunks = 0